import { createSlice } from "@reduxjs/toolkit";

import { DEFAULT_RECENT_PROJECT_COUNT, LANDING_PAGE_PREFERENCES } from "@constants/global.constants";

import { getCurrentTimezone, getDefaultNumberFormat } from "./header/UserSettings/timezoneUtils";

const initialState = {
  data: {
    UserId: 0,
    userName: null,
    EmailId: null,
    Role: null,
    lastLoggedIn: null,
    applicationVersion: null,
    CompanyName: null,
    timezone: getCurrentTimezone(),
    numberFormat: getDefaultNumberFormat().locale,
    userImage: null,
    langauage: null,
    lsttechnologyID: [],
    isBlocked: false,
    landingPageId: LANDING_PAGE_PREFERENCES.RECENT_PROJECTS,
    recentProjectCount: DEFAULT_RECENT_PROJECT_COUNT,
    expiredTechPermissions: [],
    expiredProductPermissions: [],
    isAutoSaveProject: false,
  },
  isFirstTimeLoggedIn: false,
  isROPermission: true,
  isIXPermission: true,
  startTour: {
    isStartTour: false,
    isShowTooltipStartTour: false,
  },
  isTermsAccepted: false,
};

export const UserInfoSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    updateIXPermission: (state, action) => {
      state.isIXPermission = action.payload;
    },
    updateAppVersion: (state, action) => {
      state.data.applicationVersion = action.payload;
    },
    updateUserInfoData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    updateIsFirstTimeLoggedIn: (state, action) => {
      state.isFirstTimeLoggedIn = action.payload;
    },
    updateStartTour: (state, action) => {
      state.startTour = { ...state.startTour, ...action.payload };
    },
    updateIsTermsAccepted: (state, action) => {
      state.isTermsAccepted = action.payload;
    },
  },
});

export const {
  updateStartTour,
  updateAppVersion,
  updateIXPermission,
  updateUserInfoData,
  updateIsTermsAccepted,
  updateIsFirstTimeLoggedIn,
} = UserInfoSlice.actions;
export default UserInfoSlice.reducer;
